import Model from './Model'
class TallyForm {
    constructor() {
        this.model = new Model()
    }

    async GetTallyFormLinks() {
        try {
            let url = `/tally-form/link`
            let resp = await this.model.getAsync(url)
            if (resp.success == true) {
                return resp.value
            }
            return null
        } catch (err) {
            return null
        }
    }
}
export default TallyForm;